module.exports = __webpack_public_path__ + "img/nld.d4811c27.svg";